import {
    Checkbox,
    FormControl,
    FormControlProps,
    InputLabel,
    InputLabelProps,
    InputProps, ListItemText,
    MenuItem, OutlinedInput,
    Select,
    SelectProps,
    Skeleton,
} from '@mui/material';
import React, { forwardRef } from 'react'
import { colours } from '../StyleConstants'
interface Props {
    label?: string
    LabelProps?: InputLabelProps,
    isLoading?: boolean
    options?: { value: any, label: any }[]
    error?: boolean
    FormControlProps?: FormControlProps
  InputProps?: InputProps
    multiple?: boolean
}

const MenuProps = {
    autoFocus: false,
    PaperProps: {
        style: {
            maxHeight: "200px",
            OverflowY: "scroll"
        }
    }
};

// eslint-disable-next-line react/display-name
const LassoSelect = forwardRef( (props: SelectProps & Props, ref) => {
    const { sx: selectSx, label = "", LabelProps = {}, multiple = false, value, ...selectProps } = props;
    const defaultValue = multiple ? value as string[] : value;
    const multiValue: string[] = multiple ? value as string[] : [];
    const { sx: labelSx, ...labelProps } = LabelProps;
    return (
        <FormControl
            disabled={props.disabled}
            fullWidth={props.fullWidth}
            error={props.error}
            {...props.FormControlProps}
        >
            <InputLabel
                shrink={true}
                sx={{
                    top: '-0.5rem',
                    transform: "translate(8px, -9px) scale(0.75)",
                    ...labelSx,
                }}
                {...labelProps}
            >
                {label}
            </InputLabel>
            <Select
                sx={{
                    background: colours.core.white,
                    height: "40px",
                    boxShadow: "1px 2px 5px 0px rgba(21, 24, 24, 0.10)",
                    "& fieldset": { border: 'none' },
                    "&.Mui-disabled": { backgroundColor: colours.gray.gray10 },
                    "& .MuiSelect-select": {
                        width: '100%',
                        boxSizing: 'border-box',
                        height: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                    "&.Mui-focused": {
                        border: "2px solid #80B7F8",
                    },
                    ...selectSx
                }}
                {...selectProps}
                value={value}
                defaultValue={defaultValue}
                MenuProps={MenuProps}
                startAdornment={props.isLoading ? <Skeleton width={"100%"} /> : null}
                ref={ref}
                inputProps={props?.inputProps}
                multiple={multiple}
                input={multiple ? <OutlinedInput label="Session Filter" fullWidth={props.fullWidth} /> : undefined}
                renderValue={multiple ? () => `${multiValue.length} selected` : undefined}
            >
                {props?.options?.map(({ value: name, label }) => (
                    <MenuItem key={name} value={name}>
                        {multiple ? (
                            <>
                                <Checkbox checked={multiValue.includes(label)} />
                                <ListItemText primary={label} />
                            </>
                        ) : label}
                    </MenuItem>
                )
                )}
            </Select>
        </FormControl>
    )
})
export default LassoSelect